import React from 'react';
import styled from 'styled-components';
import { useStoreActions } from 'easy-peasy';

import IWLogo from './Assets/iw-logo.svg';
import insmSrc from './Assets/insm.png';

const FooterWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;

const AdditionalLink = styled.div`
  font-size: 12px;
  color: black;
  text-align: right;

  a,
  span {
    color: black;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const INSMLogo = styled.img`
  width: 150px;
  display: block;
  margin-left: auto;
  margin-bottom: 4px;
`;

const Footer = () => {
  const setInfoboxContent = useStoreActions(
    (state) => state.info.setInfoboxContent
  );

  return (
    <FooterWrapper>
      <a rel="noopener noreferrer" target="_blank" href={config.logoLink}>
        <IWLogo width={30} height={26} />
      </a>

      <div>
        <AdditionalLink>
          <INSMLogo src={insmSrc} />

          <a rel="noopener noreferrer" target="_blank" href={config.studyLink}>
            IW-Studie im Auftrag der INSM
          </a>
        </AdditionalLink>
        <AdditionalLink style={{ marginTop: 5 }}>
          <span onClick={() => setInfoboxContent('faq')}>
            Hintergrundinformationen
          </span>
        </AdditionalLink>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
